export const GET_CLASSROOMS_REQUEST = 'GET_CLASSROOMS_REQUEST';
export const GET_CLASSROOMS_SUCCESS = 'GET_CLASSROOMS_SUCCESS';
export const GET_CLASSROOMS_FAILURE = 'GET_CLASSROOMS_FAILURE';

export const getProductClassrooms = productId =>
    ({ type: GET_CLASSROOMS_REQUEST, productId, isClassroomDataLoaded: false });

export const getProductClassroomsSuccess = ({ data }, productId) =>
    ({ type: GET_CLASSROOMS_SUCCESS, data, productId, isClassroomDataLoaded: true });

export const getProductClassroomsFailure = productId =>
    ({ type: GET_CLASSROOMS_FAILURE, data: [], productId, isClassroomDataLoaded: true });

export const CLASS_FILTER_VALUE_CLEARED = 'CLASS_FILTER_VALUE_CLEARED';
export const CLASS_FILTER_VALUE_CHANGED = 'CLASS_FILTER_VALUE_CHANGED';
export const CLASS_UPDATE_SEARCH_TERM = 'CLASS_UPDATE_SEARCH_TERM';

export const clearFilterValue = () => ({ type: CLASS_FILTER_VALUE_CLEARED });

export const changeFilterValue = (collectionName, key) => ({ type: CLASS_FILTER_VALUE_CHANGED, collectionName, key });

export const updateSearchTerm = searchTerm => ({ type: CLASS_UPDATE_SEARCH_TERM, searchTerm });

export const PRINT_STUDENTS_SIGN_IN_CARD_REQUEST = 'PRINT_STUDENTS_SIGN_IN_CARD_REQUEST';
export const PRINT_STUDENTS_SIGN_IN_CARD_SUCCESS = 'PRINT_STUDENTS_SIGN_IN_CARD_SUCCESS';
export const PRINT_STUDENTS_SIGN_IN_CARD_FAILURE = 'PRINT_STUDENTS_SIGN_IN_CARD_FAILURE';

export const printStudentsSignInCard = (selectedProductId, studentSignInCardsData) =>
    ({ type: PRINT_STUDENTS_SIGN_IN_CARD_REQUEST, selectedProductId, studentSignInCardsData, isStudentsSignInCardDownloaded: false });

export const printStudentsSignInCardSuccess = downloadUrl =>
    ({ type: PRINT_STUDENTS_SIGN_IN_CARD_SUCCESS, downloadUrl, isStudentsSignInCardDownloaded: true });

export const printStudentsSignInCardFailure = () =>
    ({ type: PRINT_STUDENTS_SIGN_IN_CARD_FAILURE, isStudentsSignInCardDownloaded: true });
export const SORT_CLASS_LIST = 'SORT_CLASS_LIST';
export const sortClassList = columnToSort => ({ type: SORT_CLASS_LIST, columnToSort });

export const RETRIEVE_SELECTED_CLASSES = 'RETRIEVE_SELECTED_CLASSES';
export const retrieveSelectedClasses = selectedClassesId => ({ type: RETRIEVE_SELECTED_CLASSES, selectedClasses: selectedClassesId });

export const ADD_CLASS_OPEN_MODAL_REQUEST = 'ADD_CLASS_OPEN_MODAL_REQUEST';
export const ADD_CLASS_CLOSE_MODAL_REQUEST = 'ADD_CLASS_CLOSE_MODAL_REQUEST';

export function openAddClassModal() {
    return {
        type: ADD_CLASS_OPEN_MODAL_REQUEST,
        showAddClassModal: true,
        showAddClassConfirmationModal: false,
        refreshList: false
    };
}

export function closeAddClassModal() {
    return {
        type: ADD_CLASS_CLOSE_MODAL_REQUEST,
        showAddClassModal: false,
        showAddClassConfirmationModal: false
    };
}

export const ADD_CLASS_REQUEST = 'ADD_CLASS_REQUEST';
export const ADD_CLASS_SUCCESS = 'ADD_CLASS_SUCCESS';
export const ADD_CLASS_FAILURE = 'ADD_CLASS_FAILURE';

export const addClass = ClassModel =>
    ({ type: ADD_CLASS_REQUEST, ClassModel, isSaveInProgress: true });

export const AddClassSuccess = () =>
    ({
        type: ADD_CLASS_SUCCESS,
        isSaveInProgress: false,
        showAddClassModal: false,
        showAddClassConfirmationModal: true,
        refreshList: true
    });

export const AddClassFailure = (failureFlag, errorMessage) =>
    ({ type: ADD_CLASS_FAILURE, isSaveInProgress: false, errorMessage, showAddClassModal: true, showAddClassValidationModal: true });

export const CLEAR_PRODUCT_COURSES = 'CLEAR_PRODUCT_COURSES';

export const clearProductCourses = () => ({ type: CLEAR_PRODUCT_COURSES });

export const GET_PRODUCT_COURSES_REQUEST = 'GET_PRODUCT_COURSES_REQUEST';
export const GET_PRODUCT_COURSES_SUCCESS = 'GET_PRODUCT_COURSES_SUCCESS';
export const GET_PRODUCT_COURSES_FAILURE = 'GET_PRODUCT_COURSES_FAILURE';

export const getProductCourses = (countryCode, productId, yearGroup) =>
    ({ type: GET_PRODUCT_COURSES_REQUEST, countryCode, productId, yearGroup, isProductCoursesLoaded: false, isProductCoursesFetching: true });

export const getProductCoursesSuccess = data =>
    ({ type: GET_PRODUCT_COURSES_SUCCESS, data, isProductCoursesLoaded: true, isProductCoursesFetching: false });

export const getProductCoursesFailure = () =>
    ({ type: GET_PRODUCT_COURSES_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });

export const DOWNLOAD_CLASS_ROLL_REQUEST = 'DOWNLOAD_CLASS_ROLL_REQUEST';
export const DOWNLOAD_CLASS_ROLL_SUCCESS = 'DOWNLOAD_CLASS_ROLL_SUCCESS';
export const DOWNLOAD_CLASS_ROLL_FAILURE = 'DOWNLOAD_CLASS_ROLL_FAILURE';

export const downloadClassRoll = (classrooms, isClassRollDownloaded) =>
    ({ type: DOWNLOAD_CLASS_ROLL_REQUEST, classrooms, isClassRollDownloaded });

export const downloadClassRollSuccess = (downloadUrl, isClassRollDownloaded) => {
    window.location.href = downloadUrl;
    return ({ type: DOWNLOAD_CLASS_ROLL_SUCCESS, isClassRollDownloaded });
};

export const downloadClassRollFailure = isClassRollDownloaded =>
    ({ type: DOWNLOAD_CLASS_ROLL_FAILURE, isClassRollDownloaded });

export const CLOSE_ADD_CLASS_VALIDATION_MODAL = 'CLOSE_ADD_CLASS_VALIDATION_MODAL';

export function closeAddClassValidationModal() {
    return {
        type: CLOSE_ADD_CLASS_VALIDATION_MODAL,
        showAddClassValidationModal: false
    };
}

export const GET_SCHOOL_COURSES_REQUEST = 'GET_SCHOOL_COURSES_REQUEST';
export const GET_SCHOOL_COURSES_SUCCESS = 'GET_SCHOOL_COURSES_SUCCESS';
export const GET_SCHOOL_COURSES_FAILURE = 'GET_SCHOOL_COURSES_FAILURE';

export const getSchoolCourses = yearGroup =>
    ({ type: GET_SCHOOL_COURSES_REQUEST, yearGroup });

export const getSchoolCoursesSuccess = data =>
    ({ type: GET_SCHOOL_COURSES_SUCCESS, data });

export const getSchoolCoursesFailure = () =>
    ({ type: GET_SCHOOL_COURSES_FAILURE });

export const DELETE_CLASSROOMS_REQUEST = 'DELETE_CLASSROOMS_REQUEST';
export const DELETE_CLASSROOMS_SUCCESS = 'DELETE_CLASSROOMS_SUCCESS';
export const DELETE_CLASSROOMS_FAILURE = 'DELETE_CLASSROOMS_FAILURE';

export const deleteClassrooms = selectedClassroomIds =>
    ({
        type: DELETE_CLASSROOMS_REQUEST,
        selectedClassroomIds,
        deletingClassrooms: true,
        refreshList: false
    });

export const deleteClassroomsSuccess = () =>
    ({
        type: DELETE_CLASSROOMS_SUCCESS,
        deletingClassrooms: false
    });

export const deleteClassroomsFailure = () =>
    ({
        type: DELETE_CLASSROOMS_FAILURE,
        deletingClassrooms: false
    });
export const SHOW_DELETE_CLASSROOMS_CONFIRMATION = 'SHOW_DELETE_CLASSROOMS_CONFIRMATION';
export const openDeleteClassroomsConfirmation = deletingEmptyClassrooms =>
    ({
        type: SHOW_DELETE_CLASSROOMS_CONFIRMATION,
        showDeleteClassroomsConfirmation: true,
        deletingEmptyClassrooms

    });

export const CLOSE_DELETE_CLASSROOMS_CONFIRMATION = 'CLOSE_DELETE_CLASSROOMS_CONFIRMATION';
export const closeDeleteClassroomsConfirmation = (isConfirm = true) =>
    ({
        type: CLOSE_DELETE_CLASSROOMS_CONFIRMATION,
        showDeleteClassroomsConfirmation: false,
        deletingEmptyClassrooms: isConfirm
    });

export const SHOW_DELETE_CLASSROOMS_SUCCESS = 'SHOW_DELETE_CLASSROOMS_SUCCESS';
export const openDeleteClassroomsSuccess = () =>
    ({
        type: SHOW_DELETE_CLASSROOMS_SUCCESS,
        showDeleteClassroomsSuccess: true

    });

export const CLOSE_DELETE_CLASSROOMS_SUCCESS = 'CLOSE_DELETE_CLASSROOMS_SUCCESS';
export const closeDeleteClassroomsSuccess = deletedClassesCount =>
    ({
        type: CLOSE_DELETE_CLASSROOMS_SUCCESS,
        showDeleteClassroomsSuccess: false,
        refreshList: true,
        deletedClassesCount
    });

export const GET_STUDENTS_BY_CLASSROOM_REQUEST = 'GET_STUDENTS_BY_CLASSROOM_REQUEST';
export const GET_STUDENTS_BY_CLASSROOM_SUCCESS = 'GET_STUDENTS_BY_CLASSROOM_SUCCESS';
export const GET_STUDENTS_BY_CLASSROOM_FAILURE = 'GET_STUDENTS_BY_CLASSROOM_FAILURE';

export const getStudentByClassroomIdRequest = classroomId =>
    ({ type: GET_STUDENTS_BY_CLASSROOM_REQUEST, classroomId, isStudentDataLoaded: false });

export const getStudentByClassroomIdSuccess = students =>
    ({ type: GET_STUDENTS_BY_CLASSROOM_SUCCESS, students, isStudentDataLoaded: true });

export const getStudentByClassroomIdFailure = () =>
    ({ type: GET_STUDENTS_BY_CLASSROOM_FAILURE, isStudentDataLoaded: true });

export const SHOW_HIDE_SIGNIN_CARD_MODAL = 'SHOW_HIDE_SIGNIN_CARD_MODAL';

export const showHideSignInCardModalRequest = status =>
    ({ type: SHOW_HIDE_SIGNIN_CARD_MODAL, showHideSignInCardModal: status });

export const CLEAR_UPF_COURSES = 'CLEAR_UPF_COURSES';

export const clearUPFCourses = () => ({ type: CLEAR_UPF_COURSES });

export const GET_UPF_COURSES = 'GET_UPF_COURSES';
export const GET_UPF_COURSES_SUCCESS = 'GET_UPF_COURSES_SUCCESS';
export const GET_UPF_COURSES_FAILURE = 'GET_UPF_COURSES_FAILURE';

export const getUPFCourses = (countryCode, productId, yearGroup) =>
    ({
        type: GET_UPF_COURSES,
        countryCode,
        productId,
        yearGroup,
        isProductCoursesLoaded: false,
        isUPFCoursesFetching: true,
        selectGenericCourses: true,
        includeGlobalCourses: true
    });

export const GET_NEW_COURSES_REQUEST = 'GET_NEW_COURSES_REQUEST';
export const GET_NEW_COURSES_SUCCESS = 'GET_NEW_COURSES_SUCCESS';
export const GET_NEW_COURSES_FAILURE = 'GET_NEW_COURSES_FAILURE';

export const getNewCourses = productId =>
    ({
        type: GET_NEW_COURSES_REQUEST,
        productId,
        isProductCoursesLoaded: false,
        isNewCoursesFetching: true
    });



// WEBPACK FOOTER //
// ./app/containers/class-roll/actions.js